import React from "react";

export default function Button({
  onClick,
  disabled = false,
  children,
  className = "",
  type = "button",
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        w-full py-3 rounded-xl font-semibold shadow-md transition
        ${disabled
          ? "bg-gray-300 text-gray-500 dark:bg-zinc-700 dark:text-gray-400 cursor-not-allowed"
          : "bg-black text-white dark:bg-white dark:text-black cursor-pointer active:scale-95"
        }
        ${className}
      `}
    >
      {children}
    </button>
  );
}